import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Cette page redirige vers la section blog de la page d'accueil
const Blog = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Rediriger vers la page d'accueil avec l'ancre #blog
    navigate('/', { replace: true });
    // Petit délai pour le scroll après navigation
    setTimeout(() => {
      const blogSection = document.getElementById('blog');
      if (blogSection) {
        blogSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  }, [navigate]);

  return null;
};

export default Blog;
